import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const BootstrapButton = withStyles({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    color: '#FFF',
    backgroundColor: '#eec738',
    borderColor: '#eec738',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#c5aa31',
      borderColor: '#c5aa31',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#c5aa31',
      borderColor: '#c5aa31',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(197,170,49,.5)',
    },
  },
})(Button);

export default function CustomizedButtons({
  style,
  customButtonClicked,
  children,
  shouldDisable,
}) {
  return (
    <BootstrapButton
      variant='contained'
      color='primary'
      disableRipple
      style={style}
      onClick={customButtonClicked}
      disabled={shouldDisable}
    >
      {children}
    </BootstrapButton>
  );
}
